"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toEmailInteractionRecord = toEmailInteractionRecord;

var _immutable = require("immutable");

var _partial = _interopRequireDefault(require("transmute/partial"));

var _pluck = _interopRequireDefault(require("transmute/pluck"));

var _EmailMediator = require("customer-data-email/schema/email/EmailMediator");

var pluckTo = (0, _pluck.default)('to');

function toEmailInteractionRecord(interactionRecord, emailContent, contacts) {
  var createRecipient = (0, _partial.default)(_EmailMediator.createRecipientRecord, contacts, null);
  var subject = emailContent.subject,
      to = emailContent.to,
      ccs = emailContent.ccs,
      bccs = emailContent.bccs,
      body = emailContent.body;
  var metadata = interactionRecord.metadata.merge({
    subject: subject,
    to: (0, _immutable.List)([createRecipient(to).to]),
    ccs: pluckTo(ccs.map(createRecipient)).toList(),
    bccs: pluckTo(bccs.map(createRecipient)).toList(),
    body: body
  });
  return interactionRecord.set('metadata', metadata);
}